import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { commonErrorResponses, emptyEnvelopeSchema, requiredPayloadEnvelope } from '../envelope.js';
import { authResponseSchema } from './auth.contract.js';
const c = initContract();
/** user-api — TOTP 2단계 인증 설정·해제·복구 코드 재발급·로그인 2차 검증. */
export const userTotpContract = c.router({
    /** TOTP 시크릿을 발급하고 otpauth URI를 내려준다. 아직 계정에 활성화하지는 않는다. */
    setup: {
        method: 'POST',
        path: '/auth/totp/setup',
        body: c.noBody(),
        responses: {
            200: requiredPayloadEnvelope(z.object({
                /** 인증 앱에 스캔할 otpauth URI다. */
                otpauthUri: z.string(),
                /** 수동 입력용 base32 시크릿이다. setup 직후 한 번만 노출한다. */
                secret: z.string(),
            })),
            ...commonErrorResponses,
        },
    },
    /** TOTP 코드를 확인하고 계정에 2FA를 활성화한다. 일회용 복구 코드를 함께 내려준다. */
    confirm: {
        method: 'POST',
        path: '/auth/totp/confirm',
        body: z.object({
            /** 인증 앱 6자리 TOTP 코드다. */
            code: z.string().optional(),
        }),
        responses: {
            200: requiredPayloadEnvelope(z.object({
                /** 활성화 직후 한 번만 보여 주는 복구 코드 평문 목록이다. */
                recoveryCodes: z.array(z.string()),
            })),
            ...commonErrorResponses,
        },
    },
    /** TOTP를 끈다. TOTP 코드 또는 비밀번호로 본인 확인이 필요하다. */
    disable: {
        method: 'POST',
        path: '/auth/totp/disable',
        body: z.object({
            /** 인증 앱 6자리 TOTP 코드다. 복구 코드는 받지 않는다. */
            code: z.string().optional(),
            /** TOTP 대신 비밀번호로 확인할 때 쓴다. */
            currentPassword: z.string().optional(),
        }),
        responses: {
            200: emptyEnvelopeSchema,
            ...commonErrorResponses,
        },
    },
    /** 활성화된 TOTP의 복구 코드를 모두 폐기하고 새로 발급한다. TOTP 시크릿과 세션은 바꾸지 않는다. */
    regenerateRecoveryCodes: {
        method: 'POST',
        path: '/auth/totp/recovery-codes/regenerate',
        body: z.object({
            /** 인증 앱 6자리 TOTP 코드다. 복구 코드는 받지 않는다. */
            code: z.string().optional(),
            /** TOTP 대신 비밀번호로 확인할 때 쓴다. */
            currentPassword: z.string().optional(),
        }),
        responses: {
            200: requiredPayloadEnvelope(z.object({
                /** 재발급 직후 한 번만 보여 주는 복구 코드 평문 목록이다. */
                recoveryCodes: z.array(z.string()),
            })),
            ...commonErrorResponses,
        },
    },
    /** 1차 로그인 후 `mfaRequired` 응답을 받은 뒤 TOTP로 최종 로그인을 완료한다. */
    verifyLogin: {
        method: 'POST',
        path: '/auth/login/verify-totp',
        body: z.object({
            /** TOTP 코드 또는 복구 코드다. */
            code: z.string().optional(),
            /** DPoP proof JWT다. */
            dpopProof: z.string().optional(),
        }),
        responses: {
            200: requiredPayloadEnvelope(authResponseSchema),
            ...commonErrorResponses,
        },
    },
});
//# sourceMappingURL=totp.contract.js.map